import PropTypes from 'prop-types';
import React from 'react';

import {
  DIMENSIONS,
  useWindowDimensions,
} from '../../../../../providers/WindowDimensionsProvider';

import { FormItemWrapper, Input, InputError } from './styled-components';

const FormInput = ({
  label,
  type,
  error,
  placeholder,
  value,
  onChange,
  testId,
  disabled,
}) => {
  const { layout } = useWindowDimensions();

  return (
    <FormItemWrapper
      width={`${layout === DIMENSIONS.MOBILE ? '100%' : 'calc(50% - 8px)'}`}
    >
      <Input
        type={type}
        id={label}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        data-testid={testId}
        className="sensitive-data"
        disabled={disabled}
      />
      {error && <InputError>{error}</InputError>}
    </FormItemWrapper>
  );
};

FormInput.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string.isRequired,
  error: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  testId: PropTypes.string,
  disabled: PropTypes.bool,
};

export default FormInput;
